export interface IDMThietBi{
    Id:number,
    IdLoaiThietBi:number,
    TenThietBi:string,
    TenLoaiThietBi:string, 
    IdHangSanXuat:number,
    TenHangSanXuat:string, 
    DiaChi:string,
    ThongTin:string,
    IdDonVi:number,
    TenDonVi: string,
    Ip: string,
    Long: string,
    Lat: string,
    TrangThai:number,
    TenDongThietBi: string,
    TenDoiTuongPrtg: string,
    MaDoiTuongPrtg: number,
    IdDongThietBi: number,
    SubnetMark: string,
    IpShare: string,
    IdPrtgCha: number,
    IdPrtg: number,
    IdChannel: Object,
    IdDoiTuongPrtg: number,
    SensorType: string
}

export class DMThietBi implements IDMThietBi{
    Id:number=0;
    IdLoaiThietBi:number=0;
    TenThietBi:string="";
    TenLoaiThietBi:string=""; 
    IdHangSanXuat:number=0;
    TenHangSanXuat:string=""; 
    DiaChi:string="";
    ThongTin:string="";
    IdDonVi:number=0;
    TenDonVi: string="";
    Ip: string="";
    Long: string="";
    Lat: string="";
    TrangThai:number=0;
    TenDongThietBi: string = "";
    TenDoiTuongPrtg: string = "";
    MaDoiTuongPrtg: number=0;
    IdDongThietBi: number=0;
    SubnetMark: string="";
    IpShare: string="";
    IdPrtgCha: number;
    IdDoiTuongPrtg: number=0;
    IdChannel: Object=null;
    IdPrtg: number;
    SensorType: string = '';
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
    
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thiet-bi/dm-thiet-bi/dm-thiet-bi.ts